import { isSafeInteger } from "lodash";
import { PrivilegeType } from "../../Enums/ChoiceEnums";
import _ from "lodash";

// Convert a string to a number
export function toInt(value?: string): number|undefined
{
    if (undefined === value)
        return;

    if (0 === value.trim().length)
        return;

    const number = +value;
    if (isNaN(number))
        return;

    return number;
}

export function privilegeName(right: PrivilegeType): string|undefined
{
    switch(right)
    {
        case PrivilegeType.None:
            return "None";
        case PrivilegeType.Read:
            return "Read";
        case PrivilegeType.ReadUpdate:
            return "Read/Update";
        case PrivilegeType.ReadUpdateWrite:
            return "Read/Update/Write";
    }
}